import React, { useEffect, useState } from 'react'
import { PROJECT_API } from '../../../../services/apiCalls/projectApiCalls';
import { DPR_API } from '../../../../services/apiCalls/dprApiCalls';
import { toast } from 'react-toastify';
import moment from 'moment';

export default function LogIncidentForm(props) {
  const [user ,setUser]=useState("");
  const [err ,setErr]=useState("");
    const [incident,setIncident]=useState({
        "ID":"",//For Update
        "LIID": "",
        "ProjectID": "",
        "ProjectName": "",
        "WhatToReport": "",
        "PlaceOfIncident": "",
        "PlaceActivityType": "",
        "IncidentType": "",
        "Location": "",
        "IncidentDate": "",
        "IncidentTime": "12:00:00",
        "HighPotentialIncident": "",
        "ContractorInvolved": "",
        "IncidentSpot": "",
        "BriefIncidentDescription": "",
        "Attachment": "",  
        "PermitDetails": "",
        "PermitNumber": "",
        "IncidentSitePhotograph": "",  
        "UserID": "",
        "ProjectDetail": ""
    });
    const fetMAx=async()=>{
        if(props.updateDate==null){
        const max= await DPR_API.MaxRow(0,1);
        let data = incident;
        if(max && max?.Status===200){
            data['LIID'] = "LIID-" +max?.MaxRow;
            console.log("dataaa",data)
            setIncident(data)
        }
    }
    }

    useEffect(()=>{
        fetMAx();
        setTimeout(() => {
        const users = JSON.parse((localStorage.getItem("state")));
        let data = incident;
        data['ProjectName'] = props?.data?.Project_Name;
        data['UserID'] = users?.user?.user_id;
        data['Location'] = props?.data?.Location;
        data['ProjectDetail'] = props?.data?.Brief_description;
        data['ProjectID'] = props?.data?.project_id;
        if(props.updateDate!==null){
                    let data = incident;
                    if(props.updateDate?.HighPotentialIncident=="Yes"){
                        let id1=document.getElementById("inlineRadio1")
                         id1.checked=true
                    }
                    if(props.updateDate?.HighPotentialIncident=="No"){
                        let id1=document.getElementById("inlineRadio2")
                        id1.checked=true
                    }
                    if(props.updateDate.ContractorInvolved=="Yes"){
                        let id1=document.getElementById("inlineRadio3")
                        id1.checked=true
                    }
                    if(props.updateDate.ContractorInvolved=="No"){
                        let id1=document.getElementById("inlineRadio4")
                        id1.checked=true
                    }
                    if(props.updateDate.PermitDetails=="Yes"){
                        let id1=document.getElementById("inlineRadio5")
                        id1.checked=true
                    }
                    if(props.updateDate.PermitDetails=="No"){
                        let id1=document.getElementById("inlineRadio6")
                        id1.checked=true
                    }
                    
                    data['LIID']=props.updateDate?.LIID;
                    data['ID']=props.updateDate?.ID;
                    data['WhatToReport']=props.updateDate?.WhatToReport
                    data['PlaceOfIncident']=props.updateDate?.PlaceOfIncident
                    data['PlaceActivityType']=props.updateDate?.PlaceActivityType
                    data['IncidentType']=props.updateDate?.IncidentType
                    data['IncidentDate']=moment(props.updateDate?.IncidentDate).format("YYYY-MM-DD")
                    data['IncidentTime']=props.updateDate?.IncidentTime
                    data['HighPotentialIncident']=props.updateDate?.HighPotentialIncident
                    data['ContractorInvolved']=props.updateDate?.ContractorInvolved
                    data['IncidentSpot']=props.updateDate?.IncidentSpot
                    data['BriefIncidentDescription']=props.updateDate?.BriefIncidentDescription
                    data['PermitDetails']=props.updateDate?.PermitDetails
                    data['PermitNumber']=props.updateDate?.PermitNumber
                    data['Attachment']=props.updateDate?.Attachment
                    data['IncidentSitePhotograph']=props.updateDate?.IncidentSitePhotograph
                    setIncident(data)
                }
        setIncident(data)
        setUser(users?.user)  
        }, 1000);  
    },[])

      const onSubmit = async () => {
debugger
           if(
            !incident.LIID || 
            !incident.ProjectID || 
            !incident.ProjectName || 
            !incident.WhatToReport || 
            !incident.PlaceOfIncident || 
            !incident.PlaceActivityType ||
            !incident.IncidentType || 
            !incident.Location || 
            !incident.IncidentDate || 
            !incident.IncidentTime || 
            !incident.HighPotentialIncident ||
            !incident.ContractorInvolved || 
            !incident.IncidentSpot || 
            !incident.BriefIncidentDescription || 
            !incident.Attachment || 
            !incident.PermitDetails ||
            !incident.PermitNumber || 
            !incident.IncidentSitePhotograph || 
            !incident.UserID){
                toast.error("All fileds must be required")
                setErr("All fileds must be required")
           }else{
         debugger
            const create = await DPR_API.Create_Update_Incident(incident);
            if (create && create?.Status == "200") {
                toast.success(create?.Message, { autoClose: 2000 })
                setTimeout(() => {
                    props?.setSelectedIndex(0)
                }, 2100);
            }
           }
        }

    const handleChange = (event) => {
        setErr("")
        const { name, value } = event.target;
        setIncident((prev) => ({ ...prev, [name]: value }));
    };

      const handleFile = async (e,type) => {
        setErr("")
           const uploaded=await PROJECT_API?.saveDocument( e.target.files[0]);
           let data = incident;
           if(type==="Attachment"){
               data['Attachment'] = uploaded?uploaded?.fileUrl:"";
           }
           if(type==="IncidentSitePhotograph"){
            data['IncidentSitePhotograph'] = uploaded?uploaded?.fileUrl:"";
           }
           setIncident(data)
        }

    return <React.Fragment>
        <div className='row mt-3'>
            <div className='col-3'>
                <label className='label-custom'>Project Name</label>
                <input type='text' disabled value={incident?.ProjectName} name='ProjectName' className='form-control shadow-none' />
            </div>
            <div className='col-3'>
                <label className='label-custom'>LI ID</label>
                <input  disabled value={incident.LIID} onChange={handleChange} name='LIID'  className='form-control shadow-none' />
            </div>
            <div className='col-3'>
                <label className='label-custom'>What to Report</label>
                <select onChange={handleChange} value={incident?.WhatToReport} name='WhatToReport'  style={{
                    width: "100%",
                    height: 31,
                    border: "1px solid #e6e3e3",
                    borderRadius: 4,
                    color: 'gray',
                    fontSize: 13,
                    paddingLeft: 10
                }}>
                    <option value={""}>--Select--</option>
                    <option value={"Injury/Property damage etc"}>Injury/Property damage etc</option>
                    <option value={"Medical Case"}>Medical Case</option>
                </select>
            </div>
            <div className='col-3'>
                <label className='label-custom'>Place of incident</label>
                <select onChange={handleChange} value={incident?.PlaceOfIncident} name='PlaceOfIncident' style={{
                    width: "100%",
                    height: 31,
                    border: "1px solid #e6e3e3",
                    borderRadius: 4,
                    color: 'gray',
                    fontSize: 13,
                    paddingLeft: 10
                }}>
                    <option value={""}>--Select--</option>
                    <option value={"Workplace"}>Workplace</option>
                    <option value={"Place of Incident"}>Place of Incident</option>
                </select>
            </div>
        </div>
        <div className='row mt-2'>
            <div className='col-3'>
                <label className='label-custom'>Place/Activity type</label>
                <input type='text' onChange={handleChange} value={incident?.PlaceActivityType} name='PlaceActivityType' className='form-control shadow-none' />
            </div>
            <div className='col-3'>
                <label className='label-custom'>Incident Type</label>
                <select onChange={handleChange} value={incident?.IncidentType} name='IncidentType' style={{
                    width: "100%",
                    height: 31,
                    border: "1px solid #e6e3e3",
                    borderRadius: 4,
                    color: 'gray',
                    fontSize: 13,
                    paddingLeft: 10
                }}>
                    <option value={""}>--Select--</option>
                    <option value={"First Aid"}>First Aid</option>
                    <option value={"Equipment Propert Damage"}>Equipment Propert Damage</option>
                    <option value={"Fatality"}>Fatality</option>
                    <option value={"Fire"}>Fire</option>
                    <option value={"Derailment"}>Derailment</option>
                    <option value={"LTI"}>LTI</option>
                    <option value={"Near Miss"}>Near Miss</option>
                    <option value={"Toxic Release"}>Toxic Release</option>
                </select>
            </div>
            <div className='col-3'>
                <label className='label-custom'>Location</label>
                <input onChange={handleChange} value={incident?.Location} disabled name='Location' className='form-control shadow-none' />
            </div>
            <div className='col-3'>
                <label className='label-custom'>Incident Date</label>
                <input type='date' onChange={handleChange} value={incident?.IncidentDate} name='IncidentDate' className='form-control shadow-none' />
            </div>
        </div>
        <div className='row mt-2'>
            <div className='col-3'>
                <label className='label-custom'>Incident Time</label>
                <input type='text' onChange={handleChange} value={incident?.IncidentTime} name='IncidentTime' className='form-control shadow-none' />
            </div>
            <div className='col-3'>
                <label className='label-custom'>High Potential Incident</label><br/>
                <div class="form-check form-check-inline">
                    <input class="form-check-input"
                    onChange={(e) => {
                        let data = incident
                        data['HighPotentialIncident'] = e.target.value;
                        setIncident(data)
                    }}
                    type="radio" name="inlineRadioOptions" id="inlineRadio1" value="Yes" />
                    <label class="form-check-label" for="inlineRadio1">Yes</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input"
                     onChange={(e) => {
                        let data = incident
                        data['HighPotentialIncident'] = e.target.value;
                        setIncident(data)
                    }}
                    type="radio" name="inlineRadioOptions" id="inlineRadio2" value="No" />
                    <label class="form-check-label" for="inlineRadio2">No</label>
                </div>
            </div>
            <div className='col-3'>
                <label className='label-custom'>Contractor Involved</label><br/>
                <div class="form-check form-check-inline">
                    <input class="form-check-input"
                    onChange={(e) => {
                        let data = incident
                        data['ContractorInvolved'] = e.target.value;
                        setIncident(data)
                    }}
                    type="radio" name="inlineRadioOptions2" id="inlineRadio3" value="Yes" />
                    <label class="form-check-label" for="inlineRadio3">Yes</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input"
                    onChange={(e) => {
                        let data = incident
                        data['ContractorInvolved'] = e.target.value;
                        setIncident(data)
                    }}
                    type="radio" name="inlineRadioOptions2" id="inlineRadio4" value="No" />
                    <label class="form-check-label" for="inlineRadio4">No</label>
                </div>
            </div>
            <div className='col-3'>
                <label className='label-custom'>Incident spot</label>
                <input type='text' onChange={handleChange} value={incident?.IncidentSpot} name='IncidentSpot' className='form-control shadow-none' />
            </div>
        </div>
        <div className='row mt-2'>
            <div className='col-3'>
                <label className='label-custom'>Brief incident description</label>
                <textarea onChange={handleChange} value={incident?.BriefIncidentDescription} name='BriefIncidentDescription' className='form-control shadow-none' />
            </div>
            <div className='col-3'>
                <label className='label-custom'>Permit Details</label><br/>
                <div class="form-check form-check-inline">
                    <input class="form-check-input"
                    onChange={(e) => {
                        let data = incident
                        data['PermitDetails'] = e.target.value;
                        setIncident(data)
                    }}
                    type="radio" name="inlineRadioOptions3" id="inlineRadio5" value="Yes" />
                    <label class="form-check-label" for="inlineRadio5">Yes</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input"
                    onChange={(e) => {
                        let data = incident
                        data['PermitDetails'] = e.target.value;
                        setIncident(data)
                    }}
                    type="radio" name="inlineRadioOptions3" id="inlineRadio6" value="No" />
                    <label class="form-check-label" for="inlineRadio6">No</label>
                </div>
            </div>
            <div className='col-3'>
                <label className='label-custom'>Permit Number</label>
                <input type='text' onChange={handleChange} value={incident?.PermitNumber} name='PermitNumber' className='form-control shadow-none' />
            </div>
            <div className='col-3'>
                <label className='label-custom'>Attachment</label>
                <input type='file'
                onChange={(e)=>handleFile(e,"Attachment")}
                className='form-control shadow-none' />
            </div>
        </div>

        <div className='row mt-2'>
            <div className='col-3'>
                <label className='label-custom'>Incident site photograph</label>
                <input type='file'  onChange={(e)=>handleFile(e,"IncidentSitePhotograph")} className='form-control shadow-none' />
            </div>
            <div className='col-1 mt-4'>
               <button className='btn btn-primary' onClick={onSubmit}>Submit</button>
            </div>
            <div className='col-1  mt-4'>
             <button className='btn btn-danger'
             onClick={()=>{
                props?.setSelectedIndex(0)
            }}
             >Cancel</button>
            </div>
            <div className='col-5 mt-4'>
                {/* <span style={{color:'red',fontSize:12}}>{err?err:""}</span> */}
            </div>
        </div>
    </React.Fragment>
}
